import { ConditionallyTriggered, NullConditionallyTriggered, ResponseValueType } from 'components/Question/types';

const isNullConditionallyTriggered = <TValue extends ResponseValueType>(
  triggerable: ConditionallyTriggered<TValue>
): triggerable is NullConditionallyTriggered<TValue> =>
  triggerable.trigger == null || (Array.isArray(triggerable.trigger) && triggerable.trigger.length === 0);

export const matchesTrigger = <TValue extends ResponseValueType>(
  triggerable: ConditionallyTriggered<TValue>,
  value?: TValue[] | TValue | null
) => {
  // When the value is expected to be an array, treat an empty array the same as a `null` value for triggers.
  const valueIsNull = value == null || (Array.isArray(value) && value.length === 0);

  if (isNullConditionallyTriggered(triggerable)) {
    switch (triggerable.nullTriggerMatchType) {
      case 'always':
        return true;
      case 'any':
        return !valueIsNull;

      // Default to 'none' since that was the legacy behaviour
      case 'none':
      default:
        return valueIsNull;
    }
  }

  const { trigger } = triggerable;
  if (typeof trigger === 'function') return trigger(value);

  if (Array.isArray(trigger)) {
    return Array.isArray(value)
      ? trigger.some((triggerValue) => value.includes(triggerValue))
      : trigger.includes(value);
  }

  return Array.isArray(value) ? value.includes(trigger) : value === trigger;
};
